/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Maybe } from '@irian-ro/util-functions';

export class Firm {

  public uuid: Maybe<string> | undefined = undefined;
  public name: Maybe<string> | undefined = undefined;
  public cif: Maybe<string> | undefined = undefined;
  public address: Maybe<string> | undefined = undefined;
  public county: Maybe<string> | undefined = undefined;
  public nrComReg: Maybe<string> | undefined = undefined;
  public phone: Maybe<string> | undefined = undefined;
  public fax: Maybe<string> | undefined = undefined;
  public capital: Maybe<number> | undefined = undefined;
  public bankAccounts: Maybe<BankAccount[]> | undefined = undefined;

  constructor(
    uuid?: string,
    name?: string,
    cif?: string,
    address?: string,
    county?: string,
    nrComReg?: string,
    phone?: string,
    fax?: string,
    capital?: number,
    bankAccounts?: BankAccount[]
  ) {
    this.uuid = uuid ? uuid : null;
    this.name = name ? name : null;
    this.cif = cif ? cif : null;
    this.address = address ? address : null;
    this.county = county ? county : null;
    this.nrComReg = nrComReg ? nrComReg : null;
    this.phone = phone ? phone : null;
    this.fax = fax ? fax : null;
    this.capital = capital ? capital : null;
    this.bankAccounts = bankAccounts ? bankAccounts : [];
  }
}

export class BankAccount {
  public uuid: Maybe<string> | undefined = undefined;
  public bank: Maybe<string> | undefined = undefined;
  public account: Maybe<string> | undefined = undefined;

  constructor(
    uuid?: string,
    bank?: string,
    account?: string
  ) {
    this.uuid = uuid ? uuid : null;
    this.bank = bank ? bank : null;
    this.account = account ? bank : null;
  }
}
